import { defineComponent as n, createBlock as r, openBlock as l, unref as m, mergeProps as p, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconComment",
  __name: "IconComment",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (h, e) => (l(), r(m(d), p(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "M7 6.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H7M6.25 10A.75.75 0 0 1 7 9.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 10M7 12.25a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5H7" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M21.75 14.5v-9a3.25 3.25 0 0 0-3.25-3.25h-13A3.25 3.25 0 0 0 2.25 5.5v9a3.25 3.25 0 0 0 3.25 3.25h.75V21a.75.75 0 0 0 1.219.586l4.794-3.836H18.5a3.25 3.25 0 0 0 3.25-3.25m-1.5 0a1.75 1.75 0 0 1-1.75 1.75h-6.325a1.25 1.25 0 0 0-.78.274L7.75 19.439V17.5a1.25 1.25 0 0 0-1.25-1.25h-1a1.75 1.75 0 0 1-1.75-1.75v-9A1.75 1.75 0 0 1 5.5 3.75h13a1.75 1.75 0 0 1 1.75 1.75v9",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
